import { ID } from './id';
import { Locales } from './locales';
import { Timestamp } from './timestamp';

// The device a push token is registered from; also the per-device keys of each `Notifications` setting.
export enum FcmTokenType {
  Desktop = 'desktop',
  Mobile = 'mobile',
}

export type FcmToken = {
  id: ID;
  token: ID;
  uid: ID;
  type: string;
  platform: string;
  version: string;
  timezone: string;
  language: Locales;
  updatedAt?: Timestamp;
  installationId?: ID;
  apnsToken?: ID;
  authorizationStatus?: number;
  osVersion?: string;
};
